import { showErrorNotification } from '../utils/showErrorNotification';
export const basicSwrOptions = {
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  shouldRetryOnError: false
};
export const errorHandlingSwrOptions = {
  ...basicSwrOptions,
  onError: () => showErrorNotification()
};
//# sourceMappingURL=swrConfig.js.map